function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.29 35.6667V3.5212C11.29 3.41747 11.3741 3.33337 11.4779 3.33337H24.5476C29.7776 3.33337 34.0173 7.5731 34.0173 12.8031C34.0173 18.033 29.7776 22.2728 24.5476 22.2728H21.245C21.1862 22.2728 21.1385 22.3204 21.1385 22.3792V35.6667C21.1385 36.219 20.6908 36.6667 20.1385 36.6667H12.29C11.7378 36.6667 11.29 36.219 11.29 35.6667Z",
  fill: "#1A3159"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2901 26.8183C10.7021 26.6346 10.2116 26.4092 9.8158 26.1473C-2.02557 20.134 17.0011 12.0138 20.7598 11.6668L20.0023 10.1516L26.0628 10.9092L21.8962 15.0759L21.26 13.3089C10.6567 18.0975 6.13156 23.7091 9.8158 26.1473C10.2625 26.3741 10.7531 26.598 11.2901 26.8183Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2898 26.8181C7.49278 25.6316 7.71013 22.8095 11.2898 19.5629V26.8181Z",
  fill: "#081727"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.3ff43ccd.svg";
export { ForwardRef as ReactComponent };